import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9b3dfc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_2 = { class: "production-data" }
const _hoisted_3 = {
  key: 0,
  class: "production-data-flow-chart"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pv_flow_chart = _resolveComponent("pv-flow-chart")!
  const _component_CSpinner = _resolveComponent("CSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(" Produkcja dla "),
    _createElementVNode("span", null, _toDisplayString(_ctx.pvInstallation.installation), 1),
    _hoisted_1,
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_ctx.pvInstallation.noErrors)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.isLoaded)
              ? _withDirectives((_openBlock(), _createBlock(_component_pv_flow_chart, {
                  key: 0,
                  data: _ctx.pvInstallation.data
                }, null, 8, ["data"])), [
                  [_vShow, _ctx.isLoaded]
                ])
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_4,
      (_ctx.pvInstallation.noErrors)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Odświeżono " + _toDisplayString(_ctx.pvInstallation.lastUpdated) + " minuty temu ", 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.msg), 1))
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ])
  ], 64))
}